// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Clock: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<g>
	<polygon points="22.05,10.5 18.9,10.5 18.9,23.1 29.92,29.72 31.5,27.13 22.05,21.53 	"/>
	<path d="M20.98,0C9.39,0,0,9.41,0,21s9.39,21,20.98,21C32.59,42,42,32.59,42,21S32.59,0,20.98,0z M21,38.97
		c-9.93,0-17.97-8.04-17.97-17.97S11.07,3.03,21,3.03S38.97,11.07,38.97,21S30.93,38.97,21,38.97z"/>
</g>
</svg>;
};

export default React.memo(Clock);
